module.exports = __webpack_public_path__ + "static/emm-005-988776d1748af4de89f9210fb06d4395.jpg";